import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const RequireAuth = ({ children, onboarded = true }) => {
  const { user, loading, onboarding } = useAuth();
  const location = useLocation();
  if (loading || (user && !onboarding)) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (onboarded && !onboarding.complete) return <Navigate to="/onboarding" replace />;
  if (!onboarded && onboarding.complete) return <Navigate to="/app" replace />;
  return children;
};
